import React, { useState } from "react";
import { FaCalendarAlt, FaClipboardList } from "react-icons/fa";

export default function EmpApplyLeave() {
  const [form, setForm] = useState({
    type: "",
    from: "",
    to: "",
    reason: "",
  });

  const leaveTypes = ["Sick Leave", "Casual Leave", "Paid Leave", "Vacation"];

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <h2 className="text-3xl font-bold mb-6 text-gray-800">Apply Leave</h2>

      <div className="bg-gradient-to-r from-blue-400 to-indigo-500 shadow-xl rounded-2xl p-6 max-w-xl mx-auto">
        <div className="space-y-5 text-white">

          {/* Leave Type */}
          <div>
            <label className="block mb-1 font-semibold">Leave Type</label>
            <select
              value={form.type}
              onChange={(e) => setForm({ ...form, type: e.target.value })}
              className="w-full p-3 rounded-lg bg-white text-gray-800 font-medium focus:outline-none focus:ring-2 focus:ring-indigo-300"
            >
              <option value="">Select Type</option>
              {leaveTypes.map((type, idx) => (
                <option key={idx} value={type}>
                  {type}
                </option>
              ))}
            </select>
          </div>

          {/* From and To Dates */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block mb-1 font-semibold">From</label>
              <div className="relative">
                <input
                  type="date"
                  value={form.from}
                  onChange={(e) => setForm({ ...form, from: e.target.value })}
                  className="w-full p-3 rounded-lg bg-white text-gray-800 focus:outline-none focus:ring-2 focus:ring-indigo-300"
                />
                <FaCalendarAlt className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400" />
              </div>
            </div>
            <div>
              <label className="block mb-1 font-semibold">To</label>
              <div className="relative">
                <input
                  type="date"
                  value={form.to}
                  onChange={(e) => setForm({ ...form, to: e.target.value })}
                  className="w-full p-3 rounded-lg bg-white text-gray-800 focus:outline-none focus:ring-2 focus:ring-indigo-300"
                />
                <FaCalendarAlt className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400" />
              </div>
            </div>
          </div>

          {/* Reason */}
          <div>
            <label className="block mb-1 font-semibold">Reason</label>
            <textarea
              value={form.reason}
              onChange={(e) => setForm({ ...form, reason: e.target.value })}
              rows={4}
              className="w-full p-3 rounded-lg bg-white text-gray-800 focus:outline-none focus:ring-2 focus:ring-indigo-300"
              placeholder="Explain the reason for leave"
            ></textarea>
          </div>

          {/* Submit Button */}
          <button
            className="w-full bg-white text-indigo-600 font-semibold py-3 rounded-lg shadow-lg hover:bg-gray-100 transition-all flex items-center justify-center space-x-2"
          >
            <FaClipboardList />
            <span>Submit Request</span>
          </button>
        </div>
      </div>
    </div>
  );
}
